import React from "react"
import {useNavigate} from "react-router";
import "./AccountButton.scss"
import {authStore} from "../../store";

function AccountButton() {

    const navigate = useNavigate()
    return <>
        <div className={"cmp-account-button"}
             onClick={() => {
                 navigate('/ums/user/me/configuration')
             }}
        >
            {authStore.initials.replace(' ', '')}
        </div>
    </>
}

export {
    AccountButton
}
